import type { CrowdLevel } from "./check-in-types";

export function crowdLevelLabel(level: CrowdLevel): string {
  switch (level) {
    case "empty": return "Empty";
    case "quiet": return "Quiet";
    case "moderate": return "Moderate";
    case "busy": return "Busy";
    case "packed": return "Packed";
  }
}

export function crowdLevelEmoji(level: CrowdLevel): string {
  switch (level) {
    case "empty": return "🟢";
    case "quiet": return "🟢";
    case "moderate": return "🟡";
    case "busy": return "🟠";
    case "packed": return "🔴";
  }
}
